module.exports = __webpack_public_path__ + "img/hr-tree-03-b-leaves.637d10f5.png";